import { Box, FlexColumn, FlexRow, FormControlLabel, GridColumn, Text, TextField } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { useExternalAPIWizardStore, TitleText, EXTERNAL_API_FORM_REQUIRED_LABEL, APISetupType, applyTextFieldStyle, WIDTH_SPACE, TOKEN_VALIDATION_URL, READ_TIMEOUT_MS, CONNECTION_TIMEOUT_MS } from "./ExternalAPIWizardStore";
import { useLocale } from "designSystem/locale";
import { ExternalAPIAdditionalParametersComponent } from "./ExternalAPIAdditionalParametersComponent";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";

export const ExternalAPIParameterSetupPage = observer(() => {
	const locale = useLocale();
	const store = useExternalAPIWizardStore();
	const {
		additionalAuthParameters,
		additionalConnectorParameters,
		additionalGeneralProperties,
		connectionTimeoutMS,
		connectionTimeoutMSError,
		connectionTimeoutMSErrorHelperTextRes,
		connectionTimeoutMSLabel,
		tokenValidationURL,
		tokenValidationURLError, 
		tokenValidationURLErrorHelperTextRes, 
		tokenValidationURLLabel,
		isAuthParametersVisible,
		readTimeoutMS,
		readTimeoutMSError,
		readTimeoutMSErrorHelperTextRes,
		readTimeoutMSLabel,
		setTokenValidationURLFilled,
		setConnectionTimeoutMS,
		setReadTimeoutMS,
		isReadonlyField,
	} = store;

	return (
		<>
			<GridColumn gap={5}>
				{isAuthParametersVisible && (
					<GridColumn borderBottom={STANDARD_BORDER_STYLE} paddingBottom={2}>
						<ExternalAPIAdditionalParametersComponent
							externalAPIAdditionalParameters={additionalAuthParameters}
							setupType={APISetupType.AUTHENTICATION}
						/>
					</GridColumn>
				)}
				<GridColumn borderBottom={STANDARD_BORDER_STYLE} paddingBottom={2}>
					<ExternalAPIAdditionalParametersComponent
						externalAPIAdditionalParameters={additionalConnectorParameters}
						setupType={APISetupType.CONNECTOR}
					/>
				</GridColumn>
				<GridColumn borderBottom={STANDARD_BORDER_STYLE} paddingBottom={2}>
					<ExternalAPIAdditionalParametersComponent
						externalAPIAdditionalParameters={additionalGeneralProperties}
						setupType={APISetupType.GENERAL}
					/>
				</GridColumn>
			</GridColumn>
			<Box paddingTop={3}>
				<FlexRow pb={3}>
					<TitleText text={locale.resource("ExternalAPIOtherConnectorSettingsTitle")} />
				</FlexRow>
				<FlexRow centerContent>
					<FlexColumn width="100%">
						<FormControlLabel
							control={(
								<TextField
									autoFocus
									defaultValue={tokenValidationURL}
									disabled={isReadonlyField(TOKEN_VALIDATION_URL)}
									error={tokenValidationURLError}
									helperTextRes={tokenValidationURLErrorHelperTextRes}
									onBlur={setTokenValidationURLFilled}
									required
									sx={applyTextFieldStyle("65%")}
								/>
							)}
							label={(
								<Text
									bold
									pl={3}
									text={tokenValidationURLLabel}
								/>
							)}
							labelPlacement="start"
							required
							sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
						/>
						<FormControlLabel
							control={(
								<TextField
									disabled={isReadonlyField(CONNECTION_TIMEOUT_MS)}
									error={connectionTimeoutMSError}
									helperTextRes={connectionTimeoutMSErrorHelperTextRes}
									onChange={setConnectionTimeoutMS}
									required
									sx={applyTextFieldStyle("65%")}
									value={!connectionTimeoutMS ? "" : connectionTimeoutMS}
								/>
							)}
							label={(
								<Text
									bold
									pl={3}
									text={connectionTimeoutMSLabel}
								/>
							)}
							labelPlacement="start"
							sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
						/>
						<FormControlLabel
							control={(
								<TextField
									disabled={isReadonlyField(READ_TIMEOUT_MS)}
									error={readTimeoutMSError}
									helperTextRes={readTimeoutMSErrorHelperTextRes}
									onChange={setReadTimeoutMS}
									required
									sx={applyTextFieldStyle("65%")}
									value={!readTimeoutMS ? "" : readTimeoutMS}
								/>
							)}
							label={(
								<Text
									bold
									pl={3}
									text={readTimeoutMSLabel}
								/>
							)}
							labelPlacement="start"
							sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
						/>
					</FlexColumn>
				</FlexRow>
			</Box>
		</>
	);
});

export default ExternalAPIParameterSetupPage;
